import { t } from '../../app/i18n';

export default {
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL',
};

export const translation = {
  AUTOMATIC: t('Automatická'),
  MANUAL: t('Manuálna'),
};



// WEBPACK FOOTER //
// ./src/common/enums/allocationType.js